import { getAccessToken } from "utils/cookies";
import API_MAP from "../../constants/api";
import axiosClient from "../axiosClient";

class ApiManagerRoom {
    getListHistoryRoom = (data,params) => {
        return axiosClient.post(API_MAP.GET_LIST_HISTORY_ROOM,data,{params:params})
    }
    getRoom = (data, startTimeRoom = false) => {
        if(startTimeRoom){
            return axiosClient.get(API_MAP.GET_ROOM+'/'+data + '?startTimeRoom=' + startTimeRoom)
        } else return axiosClient.get(API_MAP.GET_ROOM+'/'+data)
    }
    checkTypeRoom = (roomId, currentTimeDay) => {
            return axiosClient.get(API_MAP.CHECK_TYPE_ROOM+ '/' + roomId)
    }
    createRoom = (data) => {
        return axiosClient.post(API_MAP.CREATE_ROOM,data)
    }
    uploadFile = (roomId, data) => {
        return axiosClient.post(API_MAP.UPLOAD_FILE + roomId, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                token: getAccessToken(),
            }
        })
    }
    uploadFileMeeting = (slot, data) => {
        return axiosClient.post(API_MAP.UPLOAD_FILE_MEETING + slot, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                token: getAccessToken(),
            },
        })
    }
    uploadAvatar = (data) => {
        return axiosClient.post(API_MAP.UPLOAD_AVATAR, data, {
            processData: false,
            contentType: false,
            headers: {
                token: getAccessToken()
            }
        })
    }
    searchUserForRoom = (data) => {
        return axiosClient.post(API_MAP.SEARCH_USER, data)
    }
    getFiles = (data) => {
        return axiosClient.get(API_MAP.GET_FILES+data)
    }
    deleteFile = (data) => {
        return axiosClient.post(API_MAP.DELETE_FILE, data)
    }
    deleteFileWhenCreate = (data) => {
        return axiosClient.post(API_MAP.DELETE_FILE_WHEN_CREATE, data)
    }
    updateRoom = (data) => {
        return axiosClient.post(API_MAP.UPDATE_ROOM,data)
    }
    cancelRoom = (data) => {
        return axiosClient.put(API_MAP.CANCEL_ROOM + '/' + data)
    }
    restoreRoom = (data) => {
        return axiosClient.put(API_MAP.RESTORE_ROOM + '/' + data)
    }
    deleteRoom = (data) => {
        return axiosClient.delete(API_MAP.DELETE_ROOM + '/' + data)
    }
    updateStatusRoom = (data) => {
        return axiosClient.post(API_MAP.UPDATE_STATUS_ROOM,data)
    }

    getRoomByType = (type, params) => {
        return axiosClient.get(API_MAP.GET_LIST_ROOMS+'/'+type, {params: params})
    }

    getHistory = (params) => {
        return axiosClient.get(API_MAP.GET_HISTORY, {params: params})
    }

    updateEndRoom = (data) => {
        return axiosClient.post(API_MAP.UPDATE_END_ROOM,data)
    }

    joinNow = (roomName) => {
        return axiosClient.post(API_MAP.JOIN_NOW, { roomName })
    }

    statusMeeting = (data) => {
        return axiosClient.post(API_MAP.STATUS_MEETING, data)
    }

    info_inviteeStatus = (data) => {
        return axiosClient.post(API_MAP.INFO_INVITEESTATUS, {roomId: data})
    }

    getRoomByTime = (start, end) => {
        return axiosClient.get(API_MAP.ROOM_API.GET_ROOM_BY_TIME+'?start=' + start + '&end=' + end)
    }
    getDetailStatisticsRoom = (roomId, currentPage, startTimeRoom = false, isModerator = false, perPage = 10) => {
        if(isModerator){
            if(startTimeRoom){
                return axiosClient.get(API_MAP.ROOM_API.GET_DETAIL_STATISTICS_ROOM + '?roomId=' + roomId + "&page=" + currentPage + "&isModerator=" + isModerator + "&start=" + startTimeRoom + "&perPage=" + perPage);
            } else return axiosClient.get(API_MAP.ROOM_API.GET_DETAIL_STATISTICS_ROOM + '?roomId=' + roomId + "&page=" + currentPage + "&isModerator=" + isModerator + "&perPage=" + perPage);
        }

        if(startTimeRoom){
            return axiosClient.get(API_MAP.ROOM_API.GET_DETAIL_STATISTICS_ROOM + '?roomId=' + roomId + "&page=" + currentPage + "&start=" + startTimeRoom + "&perPage=" + perPage);
        } else return axiosClient.get(API_MAP.ROOM_API.GET_DETAIL_STATISTICS_ROOM + '?roomId=' + roomId + "&page=" + currentPage + "&perPage=" + perPage);
    }
    downloadDetailStatistics = (roomId) => {
        return axiosClient.get(API_MAP.ROOM_API.DOWNLOAD_DETAIL_STATISTICS+ '?roomId=' + roomId)
    }
    getListProgressRoom = (data) => {
        const {page, startTimeDay, room , username} = data
        return axiosClient.get(API_MAP.ROOM_API.GET_LIST_PROGRESS_ROOM + '?page=' + page + '&startTimeDay=' + startTimeDay + '&room=' + room + '&username=' + username)
    }
}

const apiManagerRoom = new ApiManagerRoom();


export default apiManagerRoom;